<app-page-header title="Outgoing transport location">
  <div class="btn-group">
    <app-button tertiery (buttonClick)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></app-button>
  </div>
</app-page-header>

<app-layout-row>
  @if (locations().length > 1) {
  @for (location of locations(); track location.Id) {
  <app-layout-column width="2">
    <app-index-card [item]="location" [selectedItem]="selectedLocation()" [title]="location.Name" [enabled]="viewMode()" (select)="selectLocation($event)"
      (close)="closeLocation($event, false)">
      <p>{{ location?.PartnerId ? locationPartners().get(location.PartnerId)?.PartnerName ?? '--' : '' }}</p>
      <p [title]="location.DisplayAddress">{{ location.DisplayAddress }}</p>
    </app-index-card>
  </app-layout-column>
  }
  }
</app-layout-row>

@if (!newMode()) {
<app-layout-row>
  <app-layout-column width="12">
    <div class="toolbar">
      <app-button primary *bizPermissionRequired="['Transport_Action_OutgoingLocation_Edit']" [disabled]="!viewMode() || !permissionToManage()" (buttonClick)="edit()">Edit</app-button>
      <app-button primary *bizPermissionRequired="['Transport_Action_OutgoingLocation_Delete']" [disabled]="!viewMode() || !permissionToManage()" (buttonClick)="delete()">Delete</app-button>
    </div>
  </app-layout-column>
</app-layout-row>
}

<!-- Spacer -->
<app-layout-row></app-layout-row>

<app-layout-row>
  <app-layout-column width="12">
    <ep-transport-configuration-edit [partnerRestrictedMode]="false" [transportConfiguration]="selectedLocation()" [partner]="selectedPartner()"
      [readonly]="viewMode()" (cancelled)="done()" (saved)="done()">
    </ep-transport-configuration-edit>
  </app-layout-column>
</app-layout-row>
